import {get, post, formatUrl, patch, deleteMethod} from '../../../utils/request'
import {
  JOB_LIST_URL,
  JOB_CATEGORY_LIST_URL,
  JOB_ALERT_SETTINGS,
  LIST_CITY, LIST_NEIGHBORHOOD,
  LIST_JOB_DETAIL,
  LIST_JOB_PENDING,
  LIST_INTERESTED_TALENTS,
  LIST_JOINED_TALENTS,
  LIST_WAIT_FOR_CONFIRMATION_EMPLOYER,
  LIST_OTHER_TOP_RATED_TALENT_EMPLOYER,
  EMPLOYER_MAKE_OFFER,
  EMPLOYER_CANCEL_OFFER,
  TALENT_CANCEL_INTEREST_JOB,
  LIST_JOB_ALERT
} from '../../../utils/urls'

const actions = {
  fetchJobs: async (context, payload) => {
    try {
      let response = await get(JOB_LIST_URL, payload.params)
      let status = response.status
      if (status === 200) {
        context.commit('setJobs', response.data['results'])
        context.commit('setTotalJob', response.data.count)
      }
    } catch (e) {
      context.commit('setJobs', [])
    }
  },
  fetchJobsCategory: async (context, payload) => {
    try {
      let response = await get(JOB_CATEGORY_LIST_URL, payload)
      let status = response.status
      if (status === 200) {
        context.commit('setJobsCategory', response.data['results'])
      }
    } catch (e) {
      context.commit('setJobsCategory', [])
    }
  },
  fetchJobListCity: async (context) => {
    try {
      let response = await get(LIST_CITY)
      let status = response.status
      if (status === 200) {
        context.commit('setJobListCity', response.data['results'])
      }
    } catch (e) {
      context.commit('setJobListCity', [])
    }
  },
  fetchJobListNeighborhood: async (context, payload) => {
    try {
      let url = formatUrl(LIST_NEIGHBORHOOD, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit('setJobListNeighborhood', response.data['results'])
      }
    } catch (e) {
      context.commit('setJobListNeighborhood', [])
    }
  },
  getJobProfileVideo: async (context, payload) => {
    try {
      let url = formatUrl(LIST_JOB_DETAIL, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit('setJobProfileVideo', response.data)
      }
    } catch (e) {
      context.commit('setJobProfileVideo', [])
    }
  },
  fetchJobsAlert: async (context, payload) => {
    try {
      let response = await get(LIST_JOB_ALERT, payload.params)
      let status = response.status
      if (status === 200) {
        context.commit('setJobsAlert', response.data['results'])
        context.commit('setTotalJobsAlert', response.data['count'])
      }
    } catch (e) {
      context.commit('setJobsAlert', [])
      context.commit('setTotalJobsAlert', 0)
    }
  },
  fetchJobsPending: async (context) => {
    try {
      let response = await get(LIST_JOB_PENDING)
      let status = response.status
      if (status === 200) {
        context.commit('setJobsPending', response.data['results'])
      }
    } catch (e) {
      context.commit('setJobsPending', [])
    }
  },
  fetchJobsAlertSettings: async (context) => {
    try {
      let response = await get(JOB_ALERT_SETTINGS)
      let status = response.status
      if (status === 200) {
        context.commit('setJobAlertSettings', response.data['results'])
      }
    } catch (e) {
      context.commit('setJobAlertSettings', [])
    }
  },
  postJobAlertSettings: async (context, payload) => {
    await post(JOB_ALERT_SETTINGS, payload.params)
  },
  fetchListInterestedTalents: async (context, payload) => {
    const url = formatUrl(LIST_INTERESTED_TALENTS, payload.params)
    try {
      const response = await get(url, payload.queries)
      const status = response.status
      if (status === 200) {
        context.commit('setListInterestedTalents', response.data['results'])
        context.commit('setTotalInterestedTalent', response.data['count'])
      }
    } catch (error) {
      context.commit('setListInterestedTalents', [])
      context.commit('setTotalInterestedTalent', 0)
    }
  },
  fetchListJoinedTalents: async (context, payload) => {
    const url = formatUrl(LIST_JOINED_TALENTS, payload.params)
    try {
      const response = await get(url, payload.queries)
      const status = response.status
      if (status === 200) {
        context.commit('setListJoinedTalents', response.data['results'])
        context.commit('setTotalJoinedTalent', response.data['count'])
      }
    } catch (error) {
      context.commit('setListJoinedTalents', [])
      context.commit('setTotalJoinedTalent', 0)
    }
  },
  fetchListWaitForConfirmationTalents: async (context, payload) => {
    try {
      const url = formatUrl(LIST_WAIT_FOR_CONFIRMATION_EMPLOYER, payload.params)
      const response = await get(url, payload.queries)
      const status = response.status
      if (status === 200) {
        context.commit('setListWaitForConfirmationTalents', response.data['results'])
        context.commit('setTotalWaitForConfirmationTalent', response.data['count'])
      }
    } catch (error) {
      context.commit('setListWaitForConfirmationTalents', [])
      context.commit('setTotalWaitForConfirmationTalent', 0)
    }
  },
  fetchListOtherTopRatedTalents: async (context, payload) => {
    try {
      let url = formatUrl(LIST_OTHER_TOP_RATED_TALENT_EMPLOYER, payload.params)
      const response = await get(url, payload.queries)
      const status = response.status
      if (status === 200) {
        context.commit('setListOtherTopRatedTalents', response.data['results'])
        context.commit('setTotalOtherTopRatedTalent', response.data['count'])
      }
    } catch (error) {
      context.commit('setListOtherTopRatedTalents', [])
      context.commit('setTotalOtherTopRatedTalent', 0)
    }
  },
  employerMakeOffer: (context, payload) => {
    let url = formatUrl(EMPLOYER_MAKE_OFFER, payload.params)
    return patch(url, payload.body)
  },
  employerCancelOffer: (context, payload) => {
    let url = formatUrl(EMPLOYER_CANCEL_OFFER, payload.params)
    return patch(url, payload.body)
  },
  talentCancelInterest: (context, payload) => {
    let url = formatUrl(TALENT_CANCEL_INTEREST_JOB, payload.params)
    return deleteMethod(url)
  }
}

export default actions
